import { render, staticRenderFns } from "./EventSetupBanner.vue?vue&type=template&id=25ed1350"
import script from "./EventSetupBanner.vue?vue&type=script&lang=js"
export * from "./EventSetupBanner.vue?vue&type=script&lang=js"
import style0 from "./EventSetupBanner.vue?vue&type=style&index=0&id=25ed1350&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports